import { Box, Button, Paper } from '@mui/material'
import { default as React } from 'react'
import NodataImg from "../../../assets/images/noData.png"
import DataGridComponent from "../../../components/DataGridComponent";

export default function NotificationList() {

    const columns = [
        {
            field: 'notification',
            headerName: 'Notification',
            flex: 1
        },
        {
            field: 'details',
            headerName: 'View Details',
            width: 200,
        },
    ]


    return (
        <Paper elevation={0}>
            <DataGridComponent
                sx={{
                    '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
                        backgroundColor: "#85949F !important",
                        color: "white",
                        fontWeight: 700,
                        maxHeight: 500,
                    },
                }}
                getRowId={(row) => row.id}
                rows={[]}
                columns={columns}
                disableRowSelectionOnClick
                slots={{
                    noRowsOverlay: () => <Box className='noData'><img src={NodataImg} alt='no data found' /></Box>,
                }}
                pagination
                rowsPerPageOptions={[25, 50, 100]}
            />
        </Paper>
    )
}
